angular.module('wbDashboard').controller('FundingTransferControllerAurea',
['$scope', '$timeout', '$filter', '$q', '$uibModal', 'User', 'Milestone', 'Message', 'PlanService', 'FormulaService',
function ($scope, $timeout, $filter, $q, $uibModal, User, Milestone, Message, PlanService, FormulaService) {
    $scope.transaction = {
        amount: null,
        type: null,
        inputActive: "from"
    };
    $scope.msAccounts = null;
    $scope.msAccountsDisabled = null;
    $scope.bankAccount = null;
    $scope.currentYear = new Date().getFullYear();

    //create milestone account objects
    $scope.$watchCollection(function() { return User.getMSandWallet(); }, function(milestones) {
        if (milestones) {
            $scope.msAccounts = [];
            $scope.msAccountsDisabled = [];
            angular.forEach(milestones, function(ms) {
                if ("status" in ms && ms.status !== 200) {
                    return;
                }

                angular.forEach(ms.accounts, function(account) {
                    var overviewAccount = $filter('filter')(User.getOverview().account_overview, {account_number:account.account_number});
                    if (overviewAccount.length) {
                        overviewAccount = overviewAccount[0];
                        /*jshint -W030 */
                        overviewAccount.extra || (overviewAccount.extra = {});
                        /*jshint +W030 */

                        //TODO: maybe the assist data could be stored with the ms.account rather than the overviewAccount...

                        if (!overviewAccount.extra.assist && overviewAccount.is_ira && !overviewAccount.is_pending) {
                            Milestone.iraAssist({account: overviewAccount.account_number}).then(function (data) {
                                overviewAccount.extra.assist = {};
                                overviewAccount.extra.assist.withdrawal = data.withdrawal;
                                overviewAccount.extra.assist.deposit = data.deposit;
                                if ( data.deposit.to_contribution_years ) {
                                    var formattedYears = {};

                                    if ( data.deposit.to_contribution_years.length > 1 && account.name.includes("SEP")) {
                                        data.deposit.to_contribution_years = [$scope.currentYear];
                                    } else if (data.deposit.to_contribution_years.length > 1) {
                                        //waiting on this value
                                        formattedYears[$scope.currentYear-1] = getYearInfo($scope.currentYear-1, account.metrics.previous_year_contributions);
                                    }
                                    formattedYears[$scope.currentYear] = getYearInfo($scope.currentYear, account.metrics.current_year_contributions);

                                    overviewAccount.extra.assist.deposit.formatted_years = formattedYears;

                                }
                            });
                        }
                    }
                    function getYearInfo(year, contributed) {
                        var limit = (account.annual_deposit_limit !== null) ? account.annual_deposit_limit*1 : null;
                        var limitReached = (limit !== null) ? contributed >= limit : null;
                        return {
                            year: year,
                            contributed: contributed || 0,
                            limit: limit,
                            limitReached: limitReached
                        };
                    }

                    var msa = {
                        id : ms.id + account.account_number,
                        name : ms.name + ((ms.type === 'retirement') ? " - "+account.name.replace(" ", "\xa0") : ""),
                        milestone : ms,
                        account : overviewAccount,
                        value : account.metrics.value || 0
                    };

                    if (overviewAccount.is_pending || overviewAccount.bank_account_link_status !== "ACTIVE") {
                        msa.pending = true;
                        msa.disabled = true;
                        $scope.msAccountsDisabled.push(msa);
                    }
                    $scope.msAccounts.push(msa);

                });
            });
        }
    });

    //get the active bank account
    $scope.$watchCollection(function() { return User.getBankAccounts(); }, function(bankAccounts) {
        if (bankAccounts) {
            $scope.bankAccount = angular.copy(bankAccounts.active) || false;
        }
    });

    $scope.$watchGroup(['msAccounts', 'bankAccount'], function(result) {
        var toMsa, fromMsa;
        if ($scope.msAccounts && $scope.bankAccount !== null) {
            $scope.accountOptions = [].concat($scope.bankAccount, $scope.msAccounts);
            checkPage();

            if ($scope.$stateParams.type) {
                $scope.accountOptions.forEach(function(msa) {
                    if ($scope.$stateParams.type === 'deposit') {
                        if (!msa.milestone && msa.type) {
                            //this is the bank
                            fromMsa = msa;
                        }
                        if (msa.milestone
                            && msa.milestone.id === $scope.$stateParams.msId
                            && (!msa.account.account_number || !$scope.$stateParams.accountNumber || msa.account.account_number === $scope.$stateParams.accountNumber)) {
                            //this is the milestone
                            toMsa = msa;
                        }
                    }
                });

                if (toMsa && (toMsa.milestone.type !== 'retirement' || $scope.$stateParams.accountNumber)) {
                    $scope.transaction.inputActive = "to";
                    $scope.selectChoice(toMsa);
                }
                if (fromMsa) {
                    $scope.transaction.inputActive = "from";
                    $scope.selectChoice(fromMsa);
                }

                if ($scope.$stateParams.pageStart && toMsa && fromMsa) {
                    $timeout(function() {
                        $scope.$state.go('.', {page:$scope.$stateParams.pageStart});
                    });
                }
                if ($scope.$stateParams.amount) {
                    $scope.transaction.amount = $scope.$stateParams.amount * 1;
                }

            }

            $scope.updateChoices();
        }
    });

    $scope.getDepositTime = function() {
        var depositTime = "";
        var days = {mon:1, tue:2, wed:3, thur:4, fri:5, sat:6, sun:7};
        var time = moment().utc();
        //get EST timezone
        if (time.isBetween(time.year()+"-03-10T08:00:00Z", time.year()+"-11-03T07:00:00Z")) {
            time.utcOffset("-0400");
        } else {
            time.utcOffset("-0500");
        }

        if ([days.sun, days.sat].includes(time.isoWeekday())) {
            depositTime = "SatSun";
        } else if (time.isoWeekday() === days.fri && time.hour() >= 16) {
            depositTime = "FriAfter4";
        } else if (time.hour() < 16) {
            depositTime = "MonFriBefore4";
        } else if (time.hour() >= 16) {
            depositTime = "MonThurAfter4";
        }

        return depositTime;
    };
    $scope.getTransferDisclaimerCode = function() {
        var code = "";
        if (['cash'].includes($scope.transaction.from.milestone.type) && ['cash','wallet'].includes($scope.transaction.to.milestone.type)) {
            code = "1day";
        } else if (['wallet'].includes($scope.transaction.from.milestone.type) && ['cash'].includes($scope.transaction.from.milestone.type)) {
            code = "1dayFormula";
        } else if ((!['cash', 'wallet'].includes($scope.transaction.from.milestone.type) && !$scope.transaction.from.account.is_ira )) {
            code = "1dayRebalance";
        } else {
            code = "1dayTo";
        }

        return code;
    };
    $scope.disclaimerInfoModal = function() {
        var modalInstance = $uibModal.open({
            templateUrl: "funding.disclaimer.modal.tpl.html", //id of script tag in template
            scope: $scope,
            size: 'md',
            windowClass: ''
        });
        modalInstance.result.catch(angular.noop);
    };

    //enable/disable account choices based on selections
    $scope.updateChoices = function() {
        angular.forEach($scope.accountOptions, function(account) {
            if (!account.pending) {
                account.disabled = false;
            }
            account.visible = true;

            //don't show chosen items in the choices list
            if ($scope.transaction.to === account || $scope.transaction.from === account) {
                account.visible = false;
            }

            if ($scope.transaction.inputActive === "from") {
                if (account.value < 1) {
                    account.disabled = true;
                }
                if (!$scope.transaction.to || ($scope.transaction.to && !$scope.transaction.to.milestone)) {
                    //going to bank, so any milestone can be selected
                    return;
                }

            } else if ($scope.transaction.inputActive === "to") {
                if (!$scope.transaction.from || ($scope.transaction.from && !$scope.transaction.from.milestone)) {
                    //coming from bank, so any milestone can be selected
                    return;
                }
            } else {
                account.disabled = true;
            }

            //if to/from is an IRA then can't select a milestone
            if (   ($scope.transaction.to && $scope.transaction.to.name.indexOf("IRA") > -1)
                || ($scope.transaction.from && $scope.transaction.from.name.indexOf("IRA") > -1) ) {
                if (account.milestone) {
                    account.disabled = true;
                }
            }

            //can't transfer from a milestone to an IRA
            if (    ($scope.transaction.to && $scope.transaction.to.milestone)
                 || ($scope.transaction.from && $scope.transaction.from.milestone) ) {
                if (account.name.indexOf("IRA") > -1) {
                    account.disabled = true;
                }
            }


        });
    };

    $scope.selectChoice = function(account) {
        if (     account.disabled
            && !(account.account && account.account.bank_account_link_status === "ACTIVE" && $scope.$stateParams.transactionId))
        {
            //skip this
        } else {
            $scope.transaction.selected = account;
            if ($scope.transaction.inputActive === "from") {
                $scope.transaction.from = account;
                if (!$scope.transaction.to) {
                    $scope.transaction.inputActive = "to";
                } else {
                    $scope.transaction.inputActive = null;
                }
            } else if ($scope.transaction.inputActive === "to") {
                $scope.transaction.to = account;
                if (!$scope.transaction.from) {
                    $scope.transaction.inputActive = "from";
                } else {
                    $scope.transaction.inputActive = null;
                }
            }
        }

        if ($scope.transaction.to && $scope.transaction.from) {
            if (!$scope.transaction.to.milestone) {
                $scope.transaction.type = "Withdrawal";
            } else if (!$scope.transaction.from.milestone) {
                $scope.transaction.type = "Deposit";
                var toAccount = $scope.transaction.to.account;
                //set the contribution year to only available if one exists
                try {
                    if (toAccount.extra.assist.deposit.to_contribution_years.length === 1) {
                        $scope.transaction.contribution_year = toAccount.extra.assist.deposit.to_contribution_years[0];
                    }
                } catch(e) {
                    $scope.transaction.contribution_year = null;
                }
            } else {
                $scope.transaction.type = "Transfer";
            }
        } else {
            $scope.transaction.type = null;
        }

        $scope.updateChoices();
    };
    $scope.clearChoice = function(direction) {
        $scope.transaction[direction] = null;
        $scope.transaction.type = null;
        $scope.transaction.contribution_year = null;
        $scope.transaction.reason = null;
        $scope.transaction.amount = null;
        $scope.transaction.limitRemaining = null;
        $scope.updateChoices();
    };
    $scope.selectInput = function(direction) {
        $scope.transaction.inputActive = direction;
        $scope.transaction.selected = null;
        $scope.updateChoices();
    };

    //make sure transfer amount isn't too high or too low
    $scope.$watch('forms.transfer.amount.$viewValue', function() {
        var form, max;
        form = $scope.forms.transfer;

        if (form && form.amount && form.amount.$viewValue) {
            var amount = parseFloat(parseFloat(form.amount.$viewValue.replace(/([^\d\.])/g, "")).toFixed(2));
            if ($scope.transaction.from && $scope.transaction.from.milestone && amount) {

                var marketValue = parseFloat($scope.transaction.from.value.toFixed(2));

                max = $scope.getMax(marketValue, 0);

                //determine value that should be in input
                if (0 && parseInt(amount) === parseInt(marketValue)) { //parse int will truncate rather than round
                    //this would automatically fill in the cents if the whole dollar amount matched the total
                    //but causes issues when deleting the cents
                    var split = form.amount.$viewValue.replace(/([^\d\.])/g, "").split('.');
                    if (split[1] && split[1].length === 1) {
                        //removing market value
                        $scope.transaction.amount = max;
                    } else {
                        //entering market value
                        //need to trigger view handler to format number if equal so add small decimal
                        form.amount.$setViewValue(marketValue.toFixed(2));
                        form.amount.$render();
                    }
                } else if (0 && amount > max) { // || marketValue == max) {
                    //removing updating of input to max if input too much...

                    //when marketValue == max then marketValue == min too, so can only withdrawal marketValue
                    //any more wouldn't leave $10 in the account, any less wouldn't get the $10 limit
                    $scope.transaction.amount = max;
                }
            } else {
                if (amount > 50000) {
                    $scope.transaction.amount = 50000;
                }
            }
        }

        $scope.setLimitRemaining();

    });

    $scope.$watch('transaction.contribution_year', function(selected, old) {
        if (selected && selected !== old) {
            $scope.transaction.amount = null;
            $scope.transaction.limitRemaining = null;
            $scope.setLimitRemaining();
        }
    });

    $scope.getMaxMessage = function(maxAmount) {
        var message;
        if (maxAmount <= 50000) {
            message = 'Please remember you have ' + $filter('currency')($scope.transaction.from.value) + ' available to ' + $scope.transaction.type + '.';
        } else {
            message = 'Remember, there’s a $50,000 daily limit.';
        }
        return message;
    };

    /**
     * Sets the limit remaining value after deposit amount is set
     * Or sets deposit amount to limit remaining if not set before
     */
    $scope.setLimitRemaining = function() {
        var setAmount = false;
        if ($scope.transaction.to && $scope.transaction.to.milestone && $scope.transaction.to.account.extra.assist && $scope.transaction.contribution_year) {
            if ($scope.transaction.limitRemaining == null && !$scope.transaction.amount) { // jshint ignore:line
                setAmount = true;
            }
            $scope.transaction.limitRemaining = $scope.getLimitRemaining($scope.transaction.to.account, $scope.transaction.contribution_year, $scope.transaction.amount);
            //default the amount to hit the ira limit if not reached
            if (setAmount) {
                if ($scope.transaction.limitRemaining > 0) {
                    $scope.transaction.amount = $scope.transaction.limitRemaining;
                } else {
                    $scope.transaction.amount = 0;
                }
            }
        }
    };

    /**
     * Calculates and returns limit remaining
     */
    $scope.getLimitRemaining = function(account, year, extraAmount) {
        if (account.extra.assist && year) {
            var remaining = null;
            var yearData = account.extra.assist.deposit.formatted_years[year];
            extraAmount || (extraAmount = 0); // jshint ignore:line
            if (yearData.limit !== null) {
                remaining = yearData.limit - yearData.contributed - extraAmount;
            }

            return remaining;
        }
    };

    $scope.goNext = function() {
        var page = null;

        switch ($scope.$stateParams.page) {
            case 'select':
                if (   $scope.transaction.type === "Withdrawal"
                    && $scope.transaction.from.account
                    && $scope.transaction.from.account.is_ira
                    && $scope.transaction.from.account.extra
                    && $scope.transaction.from.account.extra.assist
                    && $scope.transaction.from.account.extra.assist.withdrawal
                    && $scope.transaction.from.account.extra.assist.withdrawal.from_distribution_reasons
                    && $scope.transaction.from.account.extra.assist.withdrawal.from_distribution_reasons.length
                ) {
                    page = "reason";
                } else if (   $scope.transaction.type === "Deposit"
                           && $scope.transaction.to.account
                           && $scope.transaction.to.account.is_ira) {
                    page = "ira";
                } else {
                    page = "amount";
                }
                break;
            case 'ira':
                if (   $scope.transaction.type === "Deposit"
                    && $scope.transaction.to.account
                    && $scope.transaction.to.account.is_ira
                    && $scope.transaction.to.account.extra
                    && $scope.transaction.to.account.extra.assist
                    && $scope.transaction.to.account.extra.assist.deposit
                    && $scope.transaction.to.account.extra.assist.deposit.to_contribution_years
                    && $scope.transaction.to.account.extra.assist.deposit.to_contribution_years.length > 1
                ) {
                    page = "year";
                } else {
                    page = "amount";
                }
                break;
            case 'reason':
            case 'year':
                page = "amount";
                break;
            case 'amount':
                page = "review";
                break;
        }

        $scope.$state.go('base.funding.transfer', {page: page});
    };

    //inital page load check
    function checkPage() {
        if ($scope.msAccounts.length === $scope.msAccountsDisabled.length) {
            $scope.$state.go('base.funding.transfer', {page: "pending"}, {location: 'replace'});
        } else {
            $scope.$state.go('base.funding.transfer', {page: "select"}, {location: 'replace'});
        }
    }

    $scope.submitTransfer = function() {
        $scope.pageData.sending = true;
        var data = {};

        data.amount = $scope.transaction.amount;
        if ($scope.$stateParams.transactionId) {
            data.transaction_join = $scope.$stateParams.transactionId;
        }

        switch ($scope.transaction.type) {
            case 'Deposit':
                data.milestone_id = $scope.transaction.to.milestone.id;
                data.account_number = $scope.transaction.to.account.account_number;
                data.contribution_year = $scope.transaction.contribution_year;
                break;
            case 'Withdrawal':
                data.milestone_id = $scope.transaction.from.milestone.id;
                data.account_number = $scope.transaction.from.account.account_number;
                data.reason = $scope.transaction.reason;
                break;
            case 'Transfer':
                data.milestone_id = $scope.transaction.from.milestone.id;
                data.account_number = $scope.transaction.from.account.account_number;
                data.to_milestone_id = $scope.transaction.to.milestone.id;
                break;
        }

        if (['Deposit', 'Withdrawal'].includes($scope.transaction.type)) {
            data.axos_ach_transaction_id = "axos-transaction-id-FAKE-"+Math.random().toString(36).substring(2);
        }

        $q.when(1).then(function() {
            var promise;
            switch ($scope.transaction.type) {
                case 'Deposit':
                    promise = Milestone.deposit(data);
                    break;
                case 'Withdrawal':
                    promise = Milestone.withdraw(data);
                    break;
                case 'Transfer':
                    promise = Milestone.transfer(data);
                    break;
            }
            return promise;
        }).then(function() {

            if (    ($scope.transaction.from.milestone && $scope.transaction.from.milestone.type === 'wallet')
                 || ($scope.transaction.to.milestone && $scope.transaction.to.milestone.type === 'wallet') ) {
                FormulaService.user.retrieveFormulas(true);
            }

            return $q.all([User.retrieveActivityPending(true), User.retrieveOverview(true)]);
        }).then(function() {
            var receiptData = {};
            receiptData.amount = $scope.transaction.amount;

            switch ($scope.transaction.type) {
                case 'Deposit':
                    receiptData.action = "DEPOSIT";
                    receiptData.type = $scope.transaction.to.milestone.type;
                    receiptData.milestone_name = $scope.transaction.to.name;
                    receiptData.msId = $scope.transaction.to.milestone.name;
                    break;
                case 'Withdrawal':
                    receiptData.action = "WITHDRAW";
                    receiptData.type = $scope.transaction.from.milestone.type;
                    receiptData.milestone_name = $scope.transaction.from.name;
                    receiptData.msId = $scope.transaction.from.milestone.name;
                    receiptData.bank_name = $scope.transaction.to.name;
                    receiptData.bank_type = $scope.transaction.to.type;
                    break;
                case 'Transfer':
                    receiptData.action = "TRANSFER";
                    receiptData.type = $scope.transaction.to.milestone.type;
                    receiptData.milestone_name = $scope.transaction.to.name;
                    receiptData.msId = $scope.transaction.to.milestone.name;
            }

            $scope.$state.go("base.receipt", { receipt: receiptData}).then(function() {
                //don't recall why this is cleared out, but it's cleared too soon which causes occasional errors
                $scope.transaction.to = null;
                $scope.transaction.from = null;
                $scope.transaction.type = null;
                $scope.transaction.amount = null;
                if ($scope.forms && $scope.forms.transfer) {
                    $scope.forms.transfer.$setPristine();
                    $scope.forms.transfer.$setUntouched();
                }
                $("html, body").animate({ scrollTop: 0 }, 200);

            });

        }).catch(function(err) {
            Message.set({
                text:"Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                type: "danger"
            });
            throw err;
        }).finally(function() {
            $timeout(function() {
                $scope.pageData.sending = false;
            });
        });

    };

}]);
